import { render } from "./login.vue?vue&type=template&id=1afdd5bb&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=1afdd5bb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\Proyectos\\road-map-anteralLogin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afdd5bb"]])

export default __exports__